import { VueConstructor} from "vue";
import NavInfo from "@/interfaces/navInfoInterface";

const Nav = {
  install:(vue:VueConstructor) => {
    vue.prototype.$setNavInfo = function (param: NavInfo) {
      // @ts-ignore
      param.routerName = this.$route.name;
      setTimeout(() => {
        this.$store.commit('setNavInfo', param);
      },1)
    }
  }
}
export default Nav;
